import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { EmptyObject } from 'resources/EmptyDefaults';
import { getEntities } from 'resources/EntityData';
import { callLogsListSchema, callLogsSchema, ENTITY_CALL_LOGS, ENTITY_CALL_LOGS_LIST } from 'schema/CallLogsSchema';

import { isEntityPresentSelector } from 'components/Common/Data/DataFetcherEntitiesHelper';
import { getCompositeSchemaKey } from 'components/Common/Data/DataFetcherSuperUtils';

import CallLogsApi from './Api';

const DEFAULT_EXPAND = ['call_dispositions', 'customers'];
export const EXPAND_WITH_RECORDINGS_AND_VOICEMAILS = [...DEFAULT_EXPAND, 'recordings', 'voicemails'];
export const EXPAND_WITH_RECORDINGS_VOICEMAIL_HISTORY = [
  ...DEFAULT_EXPAND,
  'recordings',
  'voicemails',
  'call_dispositions.created_by',
  'call_dispositions.updated_by',
];
const getCallLogs = createSelector(
  getEntities,
  (_state, { paginationData } = {}) => getCompositeSchemaKey(paginationData),
  (state, { paginationData } = {}) =>
    isEntityPresentSelector(state, {
      namespace: ENTITY_CALL_LOGS_LIST,
      key: getCompositeSchemaKey(paginationData),
    }),
  (entities, schemaKey, isCalllLogsListPresent) => {
    if (!isCalllLogsListPresent) return EmptyObject;
    return denormalize(schemaKey, callLogsListSchema, entities) || EmptyObject;
  }
);

const getCallLog = createSelector(
  getEntities,
  (_state, { uuid }) => uuid,
  (state, { uuid }) => isEntityPresentSelector(state, { namespace: ENTITY_CALL_LOGS, key: uuid }),
  (entities, uuid, isCallLogsPresent) => {
    if (!isCallLogsPresent) return EmptyObject;
    return denormalize(uuid, callLogsSchema, entities) || EmptyObject;
  }
);

export const getUnacknowledgedMissedCallCount = createSelector(
  (state) => state.unacknowledgedMissedCallCount,
  (unacknowledgedMissedCallCount) => unacknowledgedMissedCallCount?.unacknowledged_missed_call_count || 0
);

export const fetchCallLogs = {
  fetchingApiFunc: CallLogsApi.index,
  paramsFromProps: ({ paginationData } = {}) => [{ ...paginationData }],
  schema: callLogsListSchema,
  selector: getCallLogs,
};

export const fetchCallLog = {
  fetchingApiFunc: CallLogsApi.show,
  paramsFromProps: ({ uuid, expand }) => [{ uuid, expand }],
  schema: callLogsSchema,
  selector: getCallLog,
};

export const fetchMissedCallCount = {
  alwaysFetch: true,
  fetchingApiFunc: CallLogsApi.getUnacknowledgedCallsCount,
  paramsFromProps: () => [],
  dataNamespace: 'unacknowledgedMissedCallCount',
  selector: getUnacknowledgedMissedCallCount,
};
